import React, { PropsWithChildren } from 'react';

export function TeaserListOl({ children }: PropsWithChildren) {
  return <ol className="teaser-list__ol">{children}</ol>;
}
